var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939090",
    fillRule: "evenodd",
    d: "M18.2906 1.72854L18.2906 18.8785L16.8621 18.8785L16.8621 1.72854L18.2906 1.72854ZM9.00494 6.02263L14.7192 10.3148L9.00494 14.5928L9.00494 11.5074L1.29107 11.5074L1.29107 9.00738L9.00494 9.00738L9.00494 6.02263Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/align_right.74dc7aa7a1dd8eec810bd37b2c127c2e.svg";
export { ForwardRef as ReactComponent };